import { Avatar, Flex, HStack, Text } from "@chakra-ui/react";
import type { BoxProps } from "@chakra-ui/react";
import { BasePill } from "./BasePill";

export interface AttributeTagProps extends BoxProps {
  label: string;
  children: React.ReactNode;
  href?: string;
}

export function AttributeTag({ label, children, href, ...rest }: AttributeTagProps) {
  return (
    <BasePill
      as={href ? "a" : "div"}
      href={href}
      cursor={href ? "pointer" : "default"}
      _hover={href ? { borderColor: "gray.300", bg: "bg.tertiary" } : {}}
      {...rest}
    >
      <Flex direction="column" gap="0">
        <Text fontSize="10px" color="content.tertiary" fontWeight="500" lineHeight="1.3">
          {label}
        </Text>
        <Text fontSize="12px" fontWeight="700" color="content.primary" lineHeight="1.3">
          {children}
        </Text>
      </Flex>
    </BasePill>
  );
}

export interface AvatarAttributeTagProps extends BoxProps {
  label: string;
  name: string;
  avatarUrl?: string;
  href?: string;
}

export function AvatarAttributeTag({ label, name, avatarUrl, href, ...rest }: AvatarAttributeTagProps) {
  return (
    <BasePill
      as={href ? "a" : "div"}
      href={href}
      cursor={href ? "pointer" : "default"}
      _hover={href ? { borderColor: "gray.300", bg: "bg.tertiary" } : {}}
      {...rest}
    >
      <HStack spacing="2" align="center">
        <Avatar name={name} src={avatarUrl} size="xs" bg="cdsIndigo.300" color="white" flexShrink={0} />
        <Flex direction="column" gap="0">
          <Text fontSize="10px" color="content.tertiary" fontWeight="500" lineHeight="1.3">
            {label}
          </Text>
          <Text fontSize="12px" fontWeight="700" color="content.primary" lineHeight="1.3">
            {name}
          </Text>
        </Flex>
      </HStack>
    </BasePill>
  );
}
